import { render, staticRenderFns } from "./org-dependency.vue?vue&type=template&id=6b925074&scoped=true"
import script from "./org-dependency.vue?vue&type=script&lang=js"
export * from "./org-dependency.vue?vue&type=script&lang=js"
import style0 from "./org-dependency.vue?vue&type=style&index=0&id=6b925074&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b925074",
  null
  
)

export default component.exports